<template>
  <div>
    <div v-if="childWithSpecialNeedsText || specialNeedsYearsExperienceText">
      <p
        v-if="specialNeedsYearsExperienceText"
        class="text-small text-grey-text-subdued"
        :class="{ 'mb-8': childWithSpecialNeedsText }"
      >
        {{ specialNeedsYearsExperienceText }}
      </p>
      <p v-if="childWithSpecialNeedsText" class="text-small text-grey-text-subdued">{{ childWithSpecialNeedsText }}</p>
    </div>
    <checkmark-list v-if="specialNeedsRecipientAgeGroups.length" :tips="specialNeedsAgeDisplay" />
    <tag-label-group
      v-if="specialNeedsCareExperience"
      :items="specialNeedsCareDisplay"
      title="Types of special needs experience"
      class="mt-16"
    />
    <tag-label-group
      v-if="specialNeedsConditionExperience"
      :items="specialNeedsConditionDisplay"
      title="Special needs conditions experience"
      class="mt-16"
    />
    <tag-label-group
      v-if="specialNeedsServiceExperience"
      :items="specialNeedsServiceDisplay"
      title="Special needs services experience"
      class="mt-16"
    />
  </div>
</template>

<script lang="ts">
import { experienceMap, ExperienceDisplay, specialNeedsYearsExperienceMap } from '../../__types__/ExperienceTypes';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';
import TagLabelGroup from '@/components/tag_label_group/TagLabelGroup.vue';

export default {
  name: 'ProfileSpecialNeedsExperience',
  components: { TagLabelGroup, CheckmarkList },
  props: {
    childWithSpecialNeeds: {
      type: Boolean,
      default: false,
    },
    specialNeedsYearsExperience: {
      type: String,
      default: null,
    },
    specialNeedsRecipientAgeGroups: {
      type: Array as () => string[],
      default: () => [],
    },
    specialNeedsCareExperience: {
      type: Array as () => string[],
      default: () => [],
    },
    specialNeedsConditionExperience: {
      type: Array as () => string[],
      default: () => [],
    },
    specialNeedsServiceExperience: {
      type: Array as () => string[],
      default: () => [],
    },
  },
  computed: {
    childWithSpecialNeedsText(): string {
      return this.childWithSpecialNeeds ? 'Has a special needs child of their own' : '';
    },
    specialNeedsYearsExperienceText(): string {
      if (!this.specialNeedsYearsExperience) return '';

      const display = specialNeedsYearsExperienceMap[this.specialNeedsYearsExperience] || this.specialNeedsYearsExperience;
      return `${display} of experience`;
    },
    specialNeedsAgeDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsRecipientAgeGroups, 'specialNeedsAges');
    },
    specialNeedsCareDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsCareExperience, 'specialNeedsCare');
    },
    specialNeedsConditionDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsConditionExperience, 'specialNeedsConditions');
    },
    specialNeedsServiceDisplay(): ExperienceDisplay[] {
      return this.mapExperienceKeys(this.specialNeedsServiceExperience, 'specialNeedsServices');
    },
  },
  methods: {
    mapExperienceKeys(keys: string[], mapType: keyof typeof experienceMap): ExperienceDisplay[] {
      return keys.map((key) => experienceMap[mapType]?.[key]).filter((item): item is ExperienceDisplay => !!item);
    },
  },
};
</script>
